export const title = 'scrynth'